module.exports = __webpack_public_path__ + "staticcomp/img/TopMenuImg.f8733d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/TopMenuImg.png
// module id = BQKx
// module chunks = 39